import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import Auth from '@aws-amplify/auth';
import { AmplifyAngularModule, AmplifyModules, AmplifyService } from 'aws-amplify-angular';
import { OneTopbarModule } from '@one/angular-kit/navigation';
import { OneIconModule } from '@one/angular-kit/icon';
import { OneCookieAcceptanceModule } from '@one/angular-kit/pattern';
import { environment } from '../environments/environment';
import { AppRouterModule } from './app-router.module';
import { AppComponent } from './app.component';
import { FooterModule } from './features/footer/footer.module';
import { HeaderModule } from './features/header/header.module';
import { ENVIRONMENT } from './core/models/environment.token';
import { MatTooltipModule } from '@angular/material/tooltip';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { appInitializerProvider } from './core/app-initializer/app-initializer.service';
import { loadingInterceptorProvider } from '@dia/dialog-reusable-components';
import { LoadingBarModule } from '@dia/dialog-reusable-components';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { AuthApiService } from './core/auth/auth-api.service';
import { AuthInterceptorService } from'./core/auth/auth-interceptor.service';
import { MatDividerModule } from '@angular/material/divider';
import { OneSnackBarModule } from '@one/angular-kit/modal';
import { MatListModule } from '@angular/material/list';
import { OneListModule } from '@one/angular-kit/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { QnSbnEserviceModule } from './features/qn-sbn-eservices/qn-sbn-eservice.module';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, RouterModule, BrowserAnimationsModule, AppRouterModule, AmplifyAngularModule, HammerModule, HttpClientModule, OneIconModule, OneTopbarModule, OneCookieAcceptanceModule, HeaderModule, FooterModule, MatBottomSheetModule, MatTooltipModule, LoadingBarModule, MatDividerModule, OneSnackBarModule, MatListModule, OneListModule, MatSidenavModule, QnSbnEserviceModule],
  providers: [
    appInitializerProvider,
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
    AuthApiService,
    {
      provide: AmplifyService,
      useFactory: () => {
        return AmplifyModules({
          Auth
        });
      }
    },
    ...environment.providers,
    { provide: ENVIRONMENT, useValue: environment },
    {
      provide: APP_BASE_HREF,
      useFactory: (platformLocation: PlatformLocation) => platformLocation.getBaseHrefFromDOM(),
      deps: [PlatformLocation]
    },
   
    loadingInterceptorProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
